export const PageInitActivityEvent = 'activity.page-init';
export const PageExitActivityEvent = 'activity.page-exit';

export interface PageExitActivityPayload {
  cause: 'unload' | 'inactive';
}
